export default __webpack_public_path__ + "static/media/preminer.dbaee370.jpeg";